import React from "react"
import { Alert, Pane, Button, DownloadIcon } from "evergreen-ui"
import { useTranslation } from "react-i18next"

function DownloadButton({ href, caption }) {
  return (
    <Button
      is="a"
      href={href}
      target="_blank"
      appearance="primary"
      iconBefore={DownloadIcon}
      height={40}
      marginTop="default"
      marginRight="0.5rem"
    >
      {caption}
    </Button>
  )
}

export default function DownloadAgreements({
  shops = { goodyear: true, multibrand: false, retail: false },
}) {
  const { i18n, t } = useTranslation()
  const { goodyear, multibrand, retail } = shops
  return (
    <>
      <Alert
        intent="none"
        title={t("Please download and read the documents below")}
        marginBottom="1rem"
      >
        <Pane display="flex">
          {goodyear && (
            <DownloadButton
              href={`/agreements/${i18n.language}/eCommerce_gy_Agreement.pdf`}
              caption={t("Goodyear E-Commerce Cooperation Agreement")}
            />
          )}
          {multibrand && (
            <DownloadButton
              href={`/agreements/${i18n.language}/eCommerce_mb_Agreement.pdf`}
              caption={t("Multibrand E-Commerce Cooperation Agreement")}
            />
          )}
          {retail && (
            <DownloadButton
              href={`/agreements/${i18n.language}/eCommerce_rt_Agreement.pdf`}
              caption={t("Retail E-Commerce Cooperation Agreement")}
            />
          )}
        </Pane>
      </Alert>
    </>
  )
}
